import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/components/api';
import type { ICreateEventPayload, IEvent } from '@/interfaces';
import routes from '@/lib/routes';
import { useUserConnected } from '@/hooks';

type TParams = {
	onSuccess?: () => void;
};

export const useRequestCreateEvent = (params?: TParams) => {
	const { userConnected } = useUserConnected();
	const { isPending, error, mutateAsync } = useMutation({
		mutationKey: [routes.api.events.create],
		mutationFn: (data: ICreateEventPayload) => {
			const formData = new FormData();
			formData.append('bannerImage', data.bannerImage, data.bannerImage.name);
			formData.append('type', data.type);
			formData.append('title', JSON.stringify(data.title));
			formData.append('description', JSON.stringify(data.description));
			formData.append('startsAt', data.startsAt);
			formData.append('endsAt', data.endsAt);
			formData.append('config', JSON.stringify(data.config));
			if (data.maxParticipants) formData.append('maxParticipants', String(data.maxParticipants));
			if (data.price) formData.append('price', String(data.price));

			return apiClient.axiosInstance
				.post<IEvent>(routes.api.events.create, formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
						...(userConnected?.token ? { Authorization: `Bearer ${userConnected.token}` } : {})
					}
				})
				.then(res => res.data)
				.catch(error => {
					throw error?.response?.data ?? error;
				});
		},
		onSuccess: () => params?.onSuccess?.()
	});

	return {
		isLoading: isPending,
		triggerCreateEvent: (data: ICreateEventPayload) => mutateAsync(data),
		error
	};
};
